"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("../../styles/components/grid-layout/card-resize-controls.less");
const CardResizeControls = () => {
    const preventDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "resize-controls s", onMouseUp: preventDrag, onMouseDown: preventDrag }),
        react_1.default.createElement("div", { className: "resize-controls e", onMouseUp: preventDrag, onMouseDown: preventDrag }),
        react_1.default.createElement("div", { className: "resize-controls w", onMouseUp: preventDrag, onMouseDown: preventDrag }),
        react_1.default.createElement("div", { className: "resize-controls n", onMouseUp: preventDrag, onMouseDown: preventDrag }),
        react_1.default.createElement("div", { className: "resize-controls-dot sw", onMouseDown: preventDrag }),
        react_1.default.createElement("div", { className: "resize-controls-dot nw", onMouseDown: preventDrag }),
        react_1.default.createElement("div", { className: "resize-controls-dot se", onMouseDown: preventDrag }),
        react_1.default.createElement("div", { className: "resize-controls-dot ne", onMouseDown: preventDrag })));
};
exports.default = CardResizeControls;
//# sourceMappingURL=card-resize-controls.js.map